import {
    createStore
} from 'vuex'

export default createStore({
    state: {
        keep_live_route: []
    },
    mutations: {
        setKeepRoute(state, data) {
            if (!state.keep_live_route.includes(data)) {
                state.keep_live_route.push(data)
            }
        },
        removeKeepRoute(state, data) {
            state.keep_live_route.splice(state.keep_live_route.indexOf(data), 1)
        }
    },
    actions: {},
    modules: {}
})